const cacheKeys = {
  all: ['fixtures'],
  leagues: () => [...cacheKeys.all, 'leagues'],
  fixtures: () => [...cacheKeys.all, 'fixtures'],
  headToHead: (opposingTeamId) => [
    ...cacheKeys.all,
    'headToHead',
    { opposingTeamId }
  ],
  events: (fixtureId) => [...cacheKeys.fixtures(), { fixtureId }, 'events'],
  lineups: (fixtureId) => [...cacheKeys.fixtures(), { fixtureId }, 'lineups'],
  stats: (fixtureId) => [...cacheKeys.fixtures(), { fixtureId }, 'stats'],
  standings: () => [...cacheKeys.all, 'standings']
}

export default {
  cacheKeys,
  endpoints: {
    leagues: '/soccer/leagues',
    fixtures: '/soccer/fixtures',
    headtohead: '/soccer/fixtures/headtohead',
    events: (fixtureId) => `/soccer/fixtures/${fixtureId}/events`,
    lineups: (fixtureId) => `/soccer/fixtures/${fixtureId}/lineups`,
    stats: (fixtureId) => `/soccer/fixtures/${fixtureId}/stats`,
    standings: '/soccer/standings'
  }
}
